import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { formPrioritiesData } from '../../ui/meetingReview/helpers/formPrioritiesData'

export const getShortTermPriorities = (financialData: IELTFinancialData): string[] => {
  if (financialData.ShortTermPriorities) {
    return formPrioritiesData(financialData.ShortTermPriorities)
  }
  return []
}
